<template>
	<v-card class="mb-3">
		<v-list-item>
			<v-list-item-content>
				<v-row no-gutters>
					<v-col cols="4" @click="viewUpcomingBooking">
						<v-skeleton-loader v-if="!avatar" type="avatar" :loading="true" width="60" height="60"> </v-skeleton-loader>

						<v-list-item-avatar v-else-if="avatar && avatar != 'no-avatar'" width="60" height="60">
							<v-img :src="avatar"></v-img>
						</v-list-item-avatar>

						<v-list-item-avatar v-else width="60" height="60">
							<v-img :src="no_avatar"></v-img>
						</v-list-item-avatar>
					</v-col>
					<v-col cols="8">
						<div @click="viewUpcomingBooking">
							<v-row no-gutters>
								<v-col cols="12">
									<v-list-item-title class="secondary--text lighten-1 font-weight-bold">{{ booking.professional.name }}</v-list-item-title>
									<v-list-item-subtitle class="subtitle-2 font-weight-bold">{{ booking.professional.profession }}</v-list-item-subtitle>
								</v-col>
							</v-row>
							<v-tooltip bottom>
								<template #activator="{ on, attrs }">
									<v-row no-gutters>
										<v-col cols="12">
											<v-list-item-subtitle class="subtitle-2 black--text font-weight-bold" v-bind="attrs" v-on="on"
												>{{ booking.start_date }} - {{ booking.end_date }}</v-list-item-subtitle
											>
										</v-col>
									</v-row>
								</template>
								<span>
									<v-list-item-group>
										<v-list-item-subtitle v-for="date in booking.booking_dates" :key="date" class="subtitle-2 font-weight-bold">{{
											date
										}}</v-list-item-subtitle>
									</v-list-item-group>
								</span>
							</v-tooltip>
							<v-row no-gutters>
								<v-col cols="12">
									<v-list-item-subtitle v-if="showTimes" class="pt-0 subtitle-2 black--text font-weight-bold"
										>{{ start_time }} - {{ end_time }}</v-list-item-subtitle
									>
									<v-list-item-subtitle v-else-if="!showTimes" class="pt-0 subtitle-2 black--text font-weight-bold">Times differ per day</v-list-item-subtitle>
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col cols="12">
									<v-list-item-subtitle class="pt-0 primary--text font-weight-bold">#{{ booking.unique_booking_code }}</v-list-item-subtitle>
								</v-col>
							</v-row>
						</div>
						<v-row no-gutters>
							<v-badge :content="unreadMessageCount" :value="unreadMessageCount" color="primary" bottom overlap bordered>
								<v-btn v-if="showMessageValid(booking.end_date)" class="white--text button-rounded mt-2" :height="25" color="accent" @click="openMessageDialog()"
									><span style="font-size: 12px">Message</span>
								</v-btn>
							</v-badge>
						</v-row>
					</v-col>
				</v-row>
			</v-list-item-content>

			<v-list-item-avatar>
				<v-icon large color="blue lighten-1" @click="viewUpcomingBooking">mdi-chevron-right</v-icon>
			</v-list-item-avatar>
		</v-list-item>
	</v-card>
</template>

<script>
import { mapActions } from 'vuex';
import { bus } from '@/main';
import store from '@/store';
import { Booking } from '@/models/booking.model';
import axios from 'axios';
import moment from 'moment';

export default {
	name: 'PracticeBookingCard',

	props: {
		booking: {
			type: Object,
			required: true,
			default: () => new Booking(),
		},
	},

	data: () => ({
		avatar: false,
		no_avatar: store.getters.noAvatar,
		showTimes: true,
		start_time: '',
		end_time: '',
		unreadMessageCount: 0,
	}),

	async mounted() {
		await this.getUnreadMessageCount();
		this.getAvatar();
		this.getTimes();
	},

	methods: {
		...mapActions('message', ['GetConversationUnreadCount']),
		viewUpcomingBooking() {
			const {
				booking_dates,
				booking_dates_times,
				professional,
				start_time,
				end_time,
				lunch,
				notes,
				id: bookingId,
				profession,
				rates,
				experience,
				accountid,
				skills,
				request_dates,
			} = this.booking;

			const booking = {
				start_time,
				end_time,
				lunch,
				notes,
				booking_dates,
				booking_dates_times,
				id: bookingId,
				profession,
				rates,
				experience,
				accountid,
				skills,
				request_dates,
			};
			store.dispatch('setPracticeViewingLocum', [{ id: professional.id, booking, source: 'viewUpcomingBooking' }]);
			bus.$emit('change-context', 'view-locum-details-card');
		},

		async getAvatar() {
			if (!this.avatar) {
				try {
					let response = await axios.get(store.getters.getDOCUMENTS + '/images/avatar/' + this.booking.professional.id, {
						headers: { Authorization: store.getters.jwtToken },
					});
					this.avatar = 'data:image/png;base64,' + response.data.data;
				} catch (err) {
					this.avatar = 'no_avatar';
				}
			}
		},

		getTimes() {
			this.showTimes = true;
			this.start_time = this.booking.start_time;
			this.end_time = this.booking.end_time;
			for (let index = 0; index < this.booking.request_dates.length; index++) {
				if (
					moment(this.booking.request_dates[index].start_time).format('HH:mm') !== this.booking.start_time ||
					moment(this.booking.request_dates[index].end_time).format('HH:mm') !== this.booking.end_time
				) {
					this.showTimes = false;
					break;
				}
			}
		},

		openMessageDialog() {
			const sentByID = this.booking.company.id;
			let receiverDetails = {
				id: this.booking.professional.id,
				name: this.booking.professional.name,
			};
			bus.$emit('show-message-dialog', receiverDetails, sentByID);
			this.unreadMessageCount = 0;
		},

		showMessageValid(reqEndDate) {
			const currentDate = new Date();
			const currentDayOfMonth = currentDate.getDate();
			const currentMonth = currentDate.getMonth(); // Be careful! January is 0, not 1
			const currentYear = currentDate.getFullYear();

			const dateString = currentYear + '-' + (currentMonth + 1).toString().padStart(2, '0') + '-' + currentDayOfMonth.toString().padStart(2, '0');
			if (reqEndDate >= dateString) return true;
			else return false;
		},

		async getUnreadMessageCount() {
			const unreadCount = await this.GetConversationUnreadCount({
				receivedByID: this.booking.company.id,
				sentByID: this.booking.professional.id,
			});
			this.unreadMessageCount = unreadCount;
		},
	},
};
</script>
